/**
 * Einzel-Apply mit Undo-Toast (T13/P2, Plan-Zeile „Undo nach Freigabe"):
 * kapselt `apply`/`discard` (für den Busy-State der Liste) + `applyWithUndo`
 * (zeigt nach erfolgreichem Übernehmen einen Sonner-Toast mit Aktion
 * „Rückgängig", die `revertSuggestions` für genau diese eine id aufruft).
 * Eigene Datei, damit `NeedsReviewList.tsx` unter dem Component-Size-Limit
 * bleibt.
 */
import { useTranslation } from 'react-i18next'
import { toast } from 'sonner'

import { useTextRunMutations } from './useSuggestionMutations'
import { useUndoRetryMutations } from './useUndoRetryMutations'

export function useApplyWithUndo() {
  const { t } = useTranslation()
  const { apply, discard } = useTextRunMutations()
  const { revert } = useUndoRetryMutations()

  const applyWithUndo = (suggestionId: string, editedValue?: string | string[]) => {
    apply.mutate(
      { suggestion_ids: [suggestionId], edited_value: editedValue },
      {
        onSuccess: () => {
          toast.success(t('channelContent.card.appliedToast', 'Übernommen'), {
            action: {
              label: t('channelContent.card.undo', 'Rückgängig'),
              onClick: () =>
                revert.mutate(
                  { suggestion_ids: [suggestionId] },
                  { onSuccess: () => toast.success(t('channelContent.card.undone', 'Zurückgesetzt')) },
                ),
            },
          })
        },
      },
    )
  }

  return { apply, discard, applyWithUndo }
}
